import makeStyles from '@mui/styles/makeStyles';

const folderBack =
  "path('M2.00001 55.9149H83C84.1046 55.9149 85 55.0195 85 53.9149V6.01669C85 4.91212 84.1046 4.01669 83 4.01669H41.4744C40.798 4.01669 40.1675 3.67481 39.7984 3.10799L38.3664 0.908693C37.9973 0.341872 37.3667 0 36.6903 0H2.00001C0.895439 0 7.62939e-06 0.89543 7.62939e-06 2V53.9149C7.62939e-06 55.0195 0.895439 55.9149 2.00001 55.9149Z')";
const folderFront =
  "path('M83 46.914H2C0.895431 46.914 0 46.0185 0 44.914V7.91744C0 6.81287 0.895431 5.91744 2 5.91744H43.5433C44.2925 5.91744 44.9788 5.49879 45.3216 4.8327L46.8204 1.92068C47.1632 1.25459 47.8495 0.835938 48.5987 0.835938H83C84.1046 0.835938 85 1.73137 85 2.83594V44.914C85 46.0185 84.1046 46.914 83 46.914Z')";

type Props = {
  isDisabled?: boolean;
};

const styles = (props: Props) =>
  makeStyles(() => ({
    mainDiv: {
      width: "135px",
      height: "135px",
      backgroundColor: "#FFFFFF",
      position: "relative",
      marginRight: "15px",
      marginBottom: "15px",
    },
    headerFolder: {
      position: "absolute",
      width: "36px",
      height: "11px",
      top: "calc(50% - 11px/2 - 22.5px)",
      left: "calc(50% - 36px/2 - 24.5px)",
      background: "#93A9BD",
      borderRadius: "2px",
    },
    headerFolderFill: {
      position: "absolute",
      width: "85px",
      height: "56px",
      top: "calc(50% - 56px/2 - 3px)",
      left: "calc(50% - 85px/2)",
      background: "#93A9BD",
      border: "1px solid #93A9BD",
      boxSizing: "border-box",
      borderRadius: "4px",
      clipPath: folderBack,
    },
    folder: {
      position: "absolute",
      width: "85px",
      height: "50px",
      top: "calc(50% - 50px/2 + 3px)",
      left: "calc(50% - 85px/2)",
      background: "#EDF5FB",
      boxSizing: "border-box",
      borderRadius: "4px",
      "&:hover": {
        backgroundColor: "#EDF5FBE6",
      },
    },
    folderItem: {
      position: "absolute",
      width: "75px",
      height: "47px",
      top: "calc(50% - 47px/2 + 1px)",
      left: "calc(50% - 75px/2)",
      background: "#308CDB",
      boxSizing: "border-box",
      borderRadius: "4px",
    },
    folderFillFront: {
      position: "absolute",
      width: "85px",
      height: "46px",
      top: "calc(50% - 46px/2 + 3px)",
      left: "calc(50% - 85px/2)",
      background: "#EDF5FB",
      boxSizing: "border-box",
      borderRadius: "4px",
      clipPath: folderFront,
      "&:hover": {
        backgroundColor: "#EDF5FBE6",
      },
    },
    quantityFiles: {
      fontSize: "10px",
      lineHeight: "15px",
      color: "#93A9BD",
      position: "absolute",
      bottom: 0,
      right: 0,
      marginRight: "2px",
      marginBottom: "2px",
    },
    containerInput: {
      display: "flex",
      flexDirection: "row",
      position: "absolute",
      bottom: 0,
      marginBottom: "10px",
      justifyContent: "center",
    },
    input: {
      fontSize: "12px",
      color: "#465869",
      lineHeight: "18px",
      textAlign: "center",
      backgroundColor: "#FFFFFF !important",
      width: "100%",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      border: "none",
      borderBottom: props?.isDisabled ? "none" : "1px solid #000000",
    },
    textDelete: {
      color: "#CF4842",
    },
    iconButton: {
      position: "absolute",
      top: 0,
      right: 0,
      color: "#465869",
      marginTop: "5px",
      padding: 0,
    },
  }));

export default styles;
